import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { InitMoodTrackerPage } from './init-mood-tracker';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    InitMoodTrackerPage,
  ],
  imports: [
    IonicPageModule.forChild(InitMoodTrackerPage),
    PipesModule,
    DirectivesModule,

  ],
})
export class InitMoodTrackerPageModule {}



// WEBPACK FOOTER //
// ./src/pages/init-mood-tracker/init-mood-tracker.module.ts